<template>
	<div class="order-table-wrap table-box">
		<el-table :data="tableData" style="width: 100%" stripe v-loading="isLoading">
			<el-table-column label="工单编号" width="100px" align="center">
				<template slot-scope="scope">
					<span class="clickCell" @click="getWorkorderDetail(scope.row.id,scope.row.title)">{{scope.row.id}}</span>
				</template>
			</el-table-column>
			<el-table-column label="工单标题" align="center">
				<template slot-scope="scope">
					<span class="title clickCell" :title="scope.row.title" @click="getWorkorderDetail(scope.row.id,scope.row.title)">{{scope.row.title}}</span>
				</template>
			</el-table-column>
			<el-table-column label="创建客服昵称" align="center">
				<template slot-scope="scope">
					<span class="title clickCell" @click="getWorkorderDetail(scope.row.id,scope.row.title)" :title="scope.row.authorName">{{scope.row.authorName}}</span>
				</template>
			</el-table-column>
			<el-table-column label="工单状态" width="100px" align="center">
				<template slot-scope="scope">
					<div @click="getWorkorderDetail(scope.row.id,scope.row.title)" class="clickCell">
						<span v-if="scope.row.status==1">待分配</span>
						<span v-if="scope.row.status==2">待回复</span>
						<span v-if="scope.row.status==3">处理中</span>
						<span v-if="scope.row.status==4">已解决</span>
						<span v-if="scope.row.status==5">已关闭</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="工单优先级" align="center">
				<template slot-scope="scope">
					<div @click="getWorkorderDetail(scope.row.id,scope.row.title)" class="clickCell">
						<span class="level low" v-if="scope.row.priority==0">低</span>
						<span class="level middle" v-if="scope.row.priority==1">中</span>
						<span class="level high" v-if="scope.row.priority==2">高</span>
						<span class="level warn" v-if="scope.row.priority==3">紧急</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="创建时间" align="center">
				<template slot-scope="scope">
					<span class="clickCell" @click="getWorkorderDetail(scope.row.id,scope.row.title)">{{scope.row.createTimeStr}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="240px" align="center">
				<template slot-scope="scope">
					<button v-if="scope.row.status<=3" class="tb-btn tb-btn-edit" @click="processOrder(scope.row.id)">已解决</button>
					<button v-if="scope.row.status<=3" class="tb-btn tb-btn-edit" @click="closeOrder(scope.row.id)">关闭</button>
					<button v-if="scope.row.status>3" class="tb-btn tb-btn-edit" @click="reopenOrder(scope.row.id)">重新打开</button>
					<button class="tb-btn" @click="delOrder(scope.row.id)">删除</button>
				</template>
			</el-table-column>
		</el-table>
	</div>

</template>

<script>
	export default {
		name: 'order-list',
		props:['filterParams'],
		data() {
			return {
				isLoading:false,
				tableData:[],
				total:0,
				filterParams1:this.filterParams
			}
		},
		created() {
			this.getOrder()
		},
		mounted() {
			eventBus.$on("searchOrder", (res) => {
			    // 工单搜索的结果
				this.filterParams1 = res
				this.$emit('paramsChange',this.filterParams1)
				this.getOrder()
			});
			eventBus.$on("handleOperate", (res) => {
				this.getOrder()
			});

		},
		watch:{
			// filterParams:{
			// 	immediate:true,
			// 	handler(val,old_val){
			// 		this.getOrder()
			// 	}
			// }
			'filterParams.pageSize':function(){
				this.getOrder()
			},
			'filterParams.pageNum':function(){
				this.getOrder()
			},
			'filterParams.status':function(){
				this.getOrder()
			}
		},
		methods: {
			/**
			 * 获取工单数据
			 */
			getOrder() {
				this.isLoading = true
				this.$http.ticketSearchAPI(this.filterParams1).then(res => {
					if (res.status == 1) {
						console.log(res)
						this.isLoading = false
						if (res.status == 1) {
							this.tableData = res.data.list
							this.total = res.data.total
							this.$emit('total',this.total)
						}
					}

				})
			},
			/**
			 * 重新打开工单
			 */
			reopenOrder(ticketId) {
				this.$http.reopenOrderAPI({
					ticketId: ticketId
				}).then(res => {
					console.log(res)
					if (res.status == 1) {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.getOrder()
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			/**
			 * 处理工单
			 */
			processOrder(ticketId){
				this.$http.processeOrderAPI({
					ticketId:ticketId
				}).then(res => {
					console.log(res)
					if(res.status==1){
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.getOrder()
					}else {
						this.$message.error(res.msg);
					}
				})
			},
			/**
			 * 关闭工单
			 */
			closeOrder(ticketId){
				this.$http.closeOrderAPI({
					ticketId:ticketId
				}).then(res => {
					console.log(res)
					if(res.status==1){
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.getOrder()
					}else {
						this.$message.error(res.msg);
					}
				})
			},
			/**
			 * 删除工单
			 */
			delOrder(ticketId) {
				this.$confirm('确认删除该工单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delOrderAPI({
						ticketId: ticketId
					}).then(res => {
						console.log(res)
						if (res.status == 1) {
							this.$message({
								message: '删除成功',
								type: 'success'
							})
							this.getOrder()
						} else {
							this.$message.error(res.msg);
						}
					})
				});

			},
			getWorkorderDetail(id, title) {
				this.selectTickid = id
				this.orderTitle = title
				eventBus.$emit("getWorkorderDetails",{
					selectTickid:this.selectTickid,
					orderTitle:this.orderTitle
				})
			},
		},
	}
</script>

<style lang="scss">
</style>
